export default "__VITE_ASSET__7241abd2__"